/** Coerce server timestamps to a valid ISO string for UI display. */
export function normalizeServerTimestamp(serverTs: unknown): string {
  const fallback = () => new Date().toISOString();

  if (serverTs == null || serverTs === '') {
    return fallback();
  }

  if (typeof serverTs === 'number') {
    if (!Number.isFinite(serverTs)) {
      return fallback();
    }
    // Unix seconds (typical ~1e9–1e10)
    if (serverTs >= 1e9 && serverTs < 1e11) {
      return new Date(serverTs * 1000).toISOString();
    }
    // Unix milliseconds
    if (serverTs >= 1e12 && serverTs < 1e14) {
      return new Date(serverTs).toISOString();
    }
    // e.g. ping events sending monotonic floats — not a wall-clock time
    return fallback();
  }

  if (typeof serverTs === 'string') {
    const trimmed = serverTs.trim();
    if (!trimmed) {
      return fallback();
    }
    const withZone = /[Zz]|[+-]\d{2}:\d{2}$/.test(trimmed)
      ? trimmed
      : `${trimmed}Z`;
    const parsed = new Date(withZone);
    if (!Number.isNaN(parsed.getTime())) {
      return withZone;
    }
    const parsedLoose = new Date(trimmed);
    if (!Number.isNaN(parsedLoose.getTime())) {
      return parsedLoose.toISOString();
    }
    return fallback();
  }

  return fallback();
}
